import { render, staticRenderFns } from "./ProcurementEditModal.vue?vue&type=template&id=224b753d&scoped=true"
import script from "./ProcurementEditModal.vue?vue&type=script&lang=js"
export * from "./ProcurementEditModal.vue?vue&type=script&lang=js"
import style0 from "./ProcurementEditModal.vue?vue&type=style&index=0&id=224b753d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b753d",
  null
  
)

export default component.exports